/* eslint-disable spire/fenced-imports */
import ServiceBase from "@affinity/Store/ServiceBase";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { Location } from "@insite/client-framework/Components/SpireRouter";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import resetCurrentCartId from "@insite/client-framework/Store/Data/Carts/Handlers/ResetCurrentCartId";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import placeOrder from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import { stringify } from "querystring";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

type Props = {
    stripeSessionId: string | undefined,
    stripeKey: string,
    completeUrl: string,
    failureUrl: string,
}

// Have a switch in this widget to detect have we already done the payment, if not display the embedded form otherwise detect the success (or failure) and process the details
/*
Check the user has a valid cart
If cart open display the embedded form as below
On returning here forllowing the redirect from the embedded form
If failure display error message allow a retry and process a failure on payment for audit
If success call the get API '/api/v1/stripesession' this will complete the cart do as much processing as possible server side
 - allow the user to proceed to the confirmation screen ideally automatic rather than the user clicking the place order buton
 - But need to assess the flow if the place order button delivers the triggers in commerce for completing the order and creating a transaction may be needed (Same with Paypal though)

 Other actions
  - store public key in commer setting
  - Tidy up this widget from a handler service alignment point of view 
  - Note the message/comment below load stripe outside the render
  - other actions to be agreed
*/
const StripePaymentElement: React.FC<Props> = ({
    // Site settings value - 2 hour
    stripeSessionId,
    stripeKey,
    completeUrl,
    failureUrl,
}) => {
    // make session ID state to react enable this correctly
    // add loading flag to enable waiting on load / single load
    // gets settings as handler step

    // Make sure to call `loadStripe` outside of a component’s render to avoid
    // recreating the `Stripe` object on every render.
    // This is your test public API key.
    const stripePromise = loadStripe(stripeKey);

    const [clientSecret, setClientSecret] = useState('');
    const [stripeSuccess, setStripeSuccess] = useState(false);
    const [stripeErrorMessage, setStripeErrorMessage] = useState('');

    useEffect(() => {
        (async () => {
            if (stripeSessionId) {
                await fetch(`/api/v1/stripesession/get?session_id=${stripeSessionId}`, {
                    method: "get",
                    })
                    .then((res) => res.json())
                    .then((data) => {
                        // setStripeErrorMessage(JSON.stringify(data));
                        setStripeSuccess(true);
                        if (data.status === 'complete' && data.validCartId && data.commerceUpdated === "True" && data.cartId)
                        {
                            window.location.href = (completeUrl + encodeURIComponent(data.cartId));
                        }
                        else
                        {
                            window.location.href = failureUrl;
                        }
                    });
            } else {
                // Create a Checkout Session as soon as the page loads
                await fetch("/api/v1/stripesession/create", {
                method: "POST",
                })
                .then((res) => res.json())
                .then((data) => setClientSecret(data.clientSecret));
            }
        })();
    }, [stripeSessionId]);

    return (
        <>
        {!stripeSuccess && (
        <div id="checkout">
            {!stripeErrorMessage && (<div>{stripeErrorMessage}</div>)}
            {clientSecret && (
            <EmbeddedCheckoutProvider
                stripe={stripePromise}
                options={{clientSecret}}
            >
                <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
            )}
        </div>
        )}
        </>
    );
};

export default StripePaymentElement;